// extracted by mini-css-extract-plugin
export default {"AddressDelete":"AddressDelete_AddressDelete__31cuH"};